import { render } from "./DivisionPlanSuccess.vue?vue&type=template&id=9aeb20d2"
import script from "./DivisionPlanSuccess.vue?vue&type=script&lang=js"
export * from "./DivisionPlanSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__